import { itemDefinitionsTypes } from './actionTypes';

export const getItemDefinitionsList = (payload: any) => {
  return {
    type: itemDefinitionsTypes.GET_ITEM_DEFINITIONS,
    payload,
  };
};

export const getItemDefinitionsListSuccess = (payload: any) => ({
  type: itemDefinitionsTypes.GET_ITEM_DEFINITIONS_SUCCESS,
  payload,
});

export const getItemDefinitionsListFail = (error: any) => ({
  type: itemDefinitionsTypes.GET_ITEM_DEFINITIONS_FAIL,
  payload: error,
});


export const getMilestoneConfigIV = () => {
  return {
    type: itemDefinitionsTypes.GET_MILESTONESCONFIG_IV,
  }
}

export const getMilestoneConfigIVSuccess = (payload: any) => {
  return {
    type: itemDefinitionsTypes.GET_MILESTONESCONFIG_IV_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigIVFail = (payload: any) => {
  return {
    type: itemDefinitionsTypes.GET_MILESTONESCONFIG_IV_FAIL,
    payload,
  }
}
